

exports.__esModule = true;
exports.base64Encode = base64Encode;
exports.base64Decode = base64Decode;
var Buffer = require('buffer/').Buffer;

function base64Encode(data) {
    return new Buffer(data).toString('base64');
}

function base64Decode(data) {
    return new Buffer(data, 'base64').toString('utf8');
}


//////////////////
// WEBPACK FOOTER
// ./js/lib/base64.js
// module id = ./js/lib/base64.js
// module chunks = 0